'use strict';
import get from 'lodash/get';
import isString from 'lodash/isString';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getOrganization} from '../../../app/model/reducers/state';
import {NoteState} from '../../../system/enums/NoteState';
import {getUserId} from '../../../auth/reducers';


const angular = require('angular');
const {forEach, fromJson, toJson} = angular;

module.exports = [
  '$modal',
  '$scope',
  '$miscUtils',
  'papaParse',
  '$toast',
  '$ngRedux',
  '$download',
  '$help',
  'CsvImportService',
  'NotificationService',
  'RoleDomain',
  'FirebaseQueueService',
  'ROOT_API_COLLECTION',
  'ROOT_API_SPEC',
  'DEFAULT_ROLES',
  'TOAST_TYPES',
  InvitesImportController];

const inviteCsvTemplate = 'name,email,role';
// eslint-disable-next-line max-len
const inviteCsvInstructions = "Please supply a name and email address to sent each invite to.\nYou must select a valid role for each user.\nInclude only one invite per row.\n\nAvailable roles are:\nowner, admin, power_user, user\n\nThe owner role has full administrative rights over the organization.\nThe person who created the organization will automatically be assigned the owner role.\nOnly an owner can grant another user in the organization the role of owner.\nThis of this as the super admin role.\n\nThe admin role has full administrative rights over the organization with 2 exceptions.\nAn admin may not make changes to owner users.\nAn admin may not request  to delete the organization or edit billing information.\n\nThe power user role is granted full access to all non-private projects and assets in the organization.\nThis includes:\n - creating and deleting projects and assets.\n - approving and rejecting tasks and requirements.\n - overriding task completion dates.\nPower users may not invite anyone, change anyone's roles, or remove anyone from the organization.\nThis is role is expected to be assigned to users like construction managers.";

function InvitesImportController(
  $modal,
  $scope,
  $miscUtils,
  papaParse,
  $toast,
  $ngRedux,
  $download,
  $help,
  CsvImportService,
  NotificationService,
  RoleDomain,
  FirebaseQueueService,
  ROOT_API_COLLECTION,
  ROOT_API_SPEC,
  DEFAULT_ROLES,
  TOAST_TYPES,
) {

  const vm = $scope.invitesImport = this;
  vm.data = null;
  vm.csvData = null;
  vm.errors = null;

  vm.readCsvData = readCsvData;
  vm.parseData = parseData;
  vm.cancel = $modal.cancel.bind($modal);
  vm.save = $miscUtils.blockPromise(save);
  vm.downloadTemplate = downloadTemplate;
  vm.viewInstructions = viewInstructions;

  const HEADERS = {
    email: {type: 'email'},
    name: {type: 'string'},
    role: {type: 'string', inList: DEFAULT_ROLES.toList()},
  };

  function downloadTemplate() {
    $download.downloadAsTextFile(inviteCsvTemplate, 'csv invites.csv');
  }

  function viewInstructions() {
    $help.showTextModal('Invite with CSV Instructions', inviteCsvInstructions);
  }

  // send the validated list to the server for creation
  function save() {
    if (!vm.data) {
      $toast.showI18nMessage({
        messageId: 'invites.import.no.data.message',
        type: $toast.TOAST_TYPES.error,
      });
      return Promise.reject(null);
    } else {
      const rootState = $ngRedux.getState();
      const organization = getOrganization(rootState);
      const organizationName = organization.name;
      const userId = getUserId(rootState);

      const requestData = __transformImportList(vm.data);

      // TODO(migration)
      const request = {
        method: 'organizations/invites/import',
        data: toJson({
          organization: getId(organization),
          invites: requestData,
        }),
      };

      // eslint-disable-next-line max-len
      const requestPromise = FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);

      // TODO(i18n)
      NotificationService.addNotification({
        name: `Create Invites for ${organizationName}`,
        removal: NotificationService.REMOVAL.DESKTOP, // may want to use NEVER here. play with this, get feedback
        promise: requestPromise,
        audio: {
          [NoteState.COMPLETE]: true,
          [NoteState.ERROR]: true,
        },
        toasts: {
          [NoteState.ERROR]: true,
        },
      });

      return requestPromise.then(_onSuccess, _onError);
    }
  }

  function _onSuccess() {
    $toast.showI18nMessage({
      messageId: 'invites.import.success.message',
      type: TOAST_TYPES.success,
    });
    // console.log('success!');
    return $modal.hide();
  }

  function _onError(error) {
    console.warn('errors occurred');
    console.error(error);

    $scope.$evalAsync(function () {
      vm.errors = null;
      if (error && isString(error.errors)) {
        try {
          vm.errors = fromJson(error.errors); // should be a JSON Array
        } catch (e) {
        }
      }

      if (!vm.errors) vm.errors = ["An error occurred processing your request"]; // TODO(i18n): convert to a message and translate
    });

    $toast.showI18nMessage({
      messageId: 'invites.import.failure.message',
      type: TOAST_TYPES.error,
    });

    // Promise rejection is required so that the stateful-button in the view will also display an error instead of success.
    return Promise.reject(error);
  }

  function readCsvData(fileContents) {
    vm.csvData = fileContents;
    parseData();
  }


  function parseData() {
    if (!vm.csvData) {
      vm.data = null;
    } else {
      vm.parsedData = papaParse.parse(vm.csvData, {skipEmptyLines: true});

      if (!_testForErrors(vm.parsedData) && _detectHeaders(vm.parsedData)) {
        // test for headers and, if so, map and return the data
        vm.data = CsvImportService.mapWithHeaders(vm.parsedData, HEADERS);

        if (_testForErrors(vm.parsedData)) {
          vm.data = null;
        }

      } else {
        // TODO: enter UI mapping mode to allow the user to specify which columns are the required headers.
        console.warn('either encountered an error or failed to detect headers?');
      }

      if (get(vm, 'parsedData.errors.length')) {
        console.warn('errors:', vm.parsedData.errors);
      }
      // console.log('csv data:', vm.csvData);
      // console.log('parsed data:', vm.parsedData);
      // console.log('processed data:', vm.data);
    }
  }

  function _testForErrors(parsedData) {
    if (parsedData.errors && parsedData.errors.length > 0) {
      vm.errors = parsedData.errors;
      return true;
    } else {
      vm.errors = null;
      return false;
    }
  }

  function _detectHeaders(parsedData) {
    if (!parsedData.data || !parsedData.data[0]) return false;
    let found = 0;

    for (let i = 0, length = parsedData.data[0].length; i < length; i++) {
      if (parsedData.data[0][i].toLowerCase() === 'email') found++;
      else if (parsedData.data[0][i].toLowerCase() === 'role') found++;
      else if (parsedData.data[0][i].toLowerCase() === 'name') found++;
    }

    return found === 3;
  }

  /**
   * convert each simple header into the required request parameters
   * @param data
   * @private
   */
  function __transformImportList(data) {
    const list = [];

    forEach(data, function (invite) {
      list.push({
        inviteeName: invite.name,
        inviteeEmail: invite.email,
        inviteeRoleId: invite.role,
        inviteeRoleCollection: RoleDomain.COLLECTION,
      });
    });

    return list;
  }

}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/admin/InvitesImportController.js